module.exports = __webpack_public_path__ + "icomoon.f28c7.woff";


//////////////////
// WEBPACK FOOTER
// ./app/fonts/spinnaker/fonts/icomoon.woff?jeuj5q
// module id = 2751
// module chunks = 0